export { default as InputFile } from './input-file';
